import { Injectable } from '@angular/core';
import {
  CompanyProfileSkeleton,
  PagedCompanyProfileAudit,
  PagedAircraftTypeRatingAudit,
  PagedCompanyAddressAudit,
  PagedCustomerDutyAudit,
  PagedDelayTypeAudit,
  PagedDepartmentAudit,
  PagedDutyTimeBufferAudit,
  PagedExpenseTypeAudit,
  PagedCrewMemberTypeAudit,
  PagedPaymentTypeAudit,
  PagedBusinessCategoryAudit,
  PagedJobGradeAudit,
  PagedStaffEventTypeAudit,
  PagedStaffGroupAudit,
  PagedDutyTimeAllowanceAudit
} from './+models/company-profile-audit.model';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CompanyProfileAuditService {
  constructor(private readonly http: HttpClient) {}

  getCompanyProfileAudits(pageNumber?: number, pageSize?: number, lastAuditLogId?: number | null) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedCompanyProfileAudit>(url);
  }

  getAircraftTypeRatingAudits(
    aircraftTypeRatingId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/AircraftTypeRating/${aircraftTypeRatingId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedAircraftTypeRatingAudit>(url);
  }

  getCompanyAddressAudits(
    companyAddressId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/CompanyAddress/${companyAddressId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedCompanyAddressAudit>(url);
  }

  getCustomerDutyAudits(
    customerDutyId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/CustomerDuty/${customerDutyId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedCustomerDutyAudit>(url);
  }

  getDelayTypeAudits(
    delayTypeId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/DelayType/${delayTypeId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedDelayTypeAudit>(url);
  }

  getDepartmentAudits(
    departmentId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/Department/${departmentId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedDepartmentAudit>(url);
  }

  getDutyTimeBufferAudits(
    dutyTimeBufferId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/DutyTimeBuffer/${dutyTimeBufferId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedDutyTimeBufferAudit>(url);
  }

  getExpenseTypeAudits(
    expenseCategoryId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/ExpenseCategory/${expenseCategoryId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedExpenseTypeAudit>(url);
  }

  getCrewMemberTypeAudits(
    crewMemberTypeId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/CrewMemberType/${crewMemberTypeId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedCrewMemberTypeAudit>(url);
  }

  getPaymentTypeAudits(
    paymentTypeId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/PaymentType/${paymentTypeId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedPaymentTypeAudit>(url);
  }

  getBusinessCategoryAudits(
    businessCategoryId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/BusinessCategory/${businessCategoryId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedBusinessCategoryAudit>(url);
  }

  getJobGradeAudits(
    jobGradeId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/JobGrade/${jobGradeId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedJobGradeAudit>(url);
  }

  getStaffEventTypeAudits(
    staffEventTypeId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/StaffEventType/${staffEventTypeId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedStaffEventTypeAudit>(url);
  }

  getStaffGroupAudits(
    staffGroupId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/StaffGroup/${staffGroupId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedStaffGroupAudit>(url);
  }

  getDutyTimeAllowanceAudits(
    dutyTimeAllowanceId: number,
    pageNumber?: number,
    pageSize?: number,
    lastAuditLogId?: number | null
  ) {
    if (!pageNumber) {
      pageNumber = 1;
    }
    if (!pageSize) {
      pageSize = 5;
    }
    let url = `/sdapi/profile/CompanyProfileAudit/DutyTimeAllowance/${dutyTimeAllowanceId}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (lastAuditLogId) {
      url = `${url}&lastAuditLogId=${lastAuditLogId}`;
    }
    return this.http.get<PagedDutyTimeAllowanceAudit>(url);
  }

  getCompanyProfileSkeleton() {
    return this.http.get<CompanyProfileSkeleton>(
      '/sdapi/profile/CompanyProfileAudit/AccountCustomerSkeleton'
    );
  }
}
